import { Buffer } from "buffer";

// @ts-ignore
window.Buffer = window.Buffer ?? Buffer;

import "core-js/stable/aggregate-error";
import "core-js/stable/array/at";
import "core-js/stable/array/flat";
import "core-js/stable/array/flat-map";
import "core-js/stable/array/find-last-index";
import "core-js/stable/object/from-entries";
import "core-js/stable/promise/any";
import "core-js/stable/promise/all-settled";
import "core-js/stable/promise/with-resolvers";
